import { BreadcrumbItem, Col, Row } from "reactstrap"
import { Link } from "react-router-dom"

import PropTypes from "prop-types"
import React from "react";

const AdminUserProfileBreadCrumb = ({ breadcrumbItem, title }) => {
  return (
    <Row>
      <Col md={12} xs="12">
        <div className="page-title-box pb-2 d-sm-flex align-items-center justify-content-between">
          
            <h4 className="text-capitalize text-black mb-0 font-size-18">
            {breadcrumbItem}
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#" className="text-black">{title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to="#" className="text-black">{breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

AdminUserProfileBreadCrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
}
export default AdminUserProfileBreadCrumb
